import React from "react";
/* eslint-disable */
import {
  Box, TableHead, TableBody, TableCell, TableContainer, TableRow, Table
} from '@material-ui/core';
import moment from 'moment';

export default class ComponentToPrint extends React.Component {

  render() {
    const reportData = this.props.reportData;
    const data = this.props.searchData;
    const totalValues = this.props.totalRowValue;
    const emptyRows = 0;

    return (
      <div style={{ padding: '10px' }}>
        <style>
          {`
            @media print {
              @page {
                size: auto;
                margin: 0;
              }
            }
          `}
        </style>
        <h3><center><u>Quantity Variance Report</u></center></h3>
        <div>&nbsp;</div>

        <div>&nbsp;</div>
        <Box minWidth={1050}>
          <TableContainer style={{ marginLeft: '5px' }}>
            <Table aria-label="caption table">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold", border: "1px solid black" }} align="left">Date</TableCell>
                  <TableCell sx={{ fontWeight: "bold", border: "1px solid black" }} align="left">GTN No</TableCell>
                  <TableCell sx={{ fontWeight: "bold", border: "1px solid black" }} align="left">Vehicle No</TableCell>
                  <TableCell sx={{ fontWeight: "bold", border: "1px solid black" }} align="left">SKU Code</TableCell>
                  <TableCell sx={{ fontWeight: "bold", border: "1px solid black" }} align="left">SKU Name</TableCell>
                  <TableCell sx={{ fontWeight: "bold", border: "1px solid black" }} align="left">FCC Name</TableCell>
                  <TableCell sx={{ fontWeight: "bold", border: "1px solid black" }} align="right">FCC Outbound Quantity</TableCell>
                  <TableCell sx={{ fontWeight: "bold", border: "1px solid black" }} align="right">FDC Inbound Quantity</TableCell>
                  <TableCell sx={{ fontWeight: "bold", border: "1px solid black" }} align="right">Variance</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {(() => {
                  const groupedData = [];
                  reportData.forEach((item) => {
                    const lastGroup = groupedData[groupedData.length - 1];
                    if (
                      lastGroup &&
                      lastGroup.grnNumber === item.grnNumber &&
                      lastGroup.vehicleNumber === item.vehicleNumber
                    ) {
                      lastGroup.rows.push(item);
                    } else {
                      groupedData.push({
                        grnNumber: item.grnNumber,
                        vehicleNumber: item.vehicleNumber,
                        rows: [item],
                      });
                    }
                  });
                  return groupedData.map((group, groupIndex) => (
                    <React.Fragment key={groupIndex}>
                      {group.rows.map((row, rowIndex) => (
                        <TableRow key={rowIndex}>
                          <TableCell sx={{ border: "1px solid black" }} align="left">{moment(row.grnDate).format("YYYY/MM/DD")}</TableCell>
                          {rowIndex === 0 && (
                            <TableCell
                              sx={{ border: "1px solid black" }}
                              align="left"
                              rowSpan={group.rows.length}
                            >
                              {group.grnNumber}
                            </TableCell>
                          )}
                          {rowIndex === 0 && (
                            <TableCell
                              sx={{ border: "1px solid black" }}
                              align="left"
                              rowSpan={group.rows.length}
                            >
                              {group.vehicleNumber}
                            </TableCell>
                          )}
                          <TableCell sx={{ border: "1px solid black" }} align="left">{row.skuCode}</TableCell>
                          <TableCell sx={{ border: "1px solid black" }} align="left">{row.skuName}</TableCell>
                          <TableCell sx={{ border: "1px solid black" }} align="left">{row.fccName}</TableCell>
                          <TableCell sx={{ border: "1px solid black" }} align="right">{row.totalFCCoutboundAmout == 0 ? '-' : parseFloat(row.totalFCCoutboundAmout).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                          <TableCell sx={{ border: "1px solid black" }} align="right">{parseFloat(row.totalFDCoutboundAmout).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                          <TableCell sx={{ border: "1px solid black" }} align="right">{parseFloat(row.totalFCCoutboundAmout - row.totalFDCoutboundAmout).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>

                        </TableRow>
                      ))}
                    </React.Fragment>
                  ));
                })()}
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold", border: "1px solid black" }} colSpan={6}>Total</TableCell>
                  <TableCell sx={{ fontWeight: "bold", border: "1px solid black" }} align="right">{totalValues.totalFCCoutboundAmout == 0 ? '-' : parseFloat(totalValues.totalFCCoutboundAmout).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                  <TableCell sx={{ fontWeight: "bold", border: "1px solid black" }} align="right">{parseFloat(totalValues.totalFDCoutboundAmout).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                  <TableCell sx={{ fontWeight: "bold", border: "1px solid black" }} align="right">{totalValues.totalVarience == 0 ? '-' : parseFloat(totalValues.totalVarience).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                </TableRow>
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </div>
    );
  }
}
